import { useSelector } from 'react-redux';

import { getCompanyName, getLogo } from 'common/helpers/miscHelper';

const Logo = () => {
  const settings = useSelector((state) => state.setting);
  const logo = getLogo(settings);
  if (!logo) {
    return <div className="c7-checkout__header__logo">Your Logo Here</div>;
  }
  return (
    <div className="c7-checkout__header__logo">
      <a href="/">
        <img src={logo} alt={getCompanyName(settings)} />
      </a>
    </div>
  );
};
export default Logo;
